import { useTranslation } from 'react-i18next';
import { TextV2 } from '@insights-ltd/design-library/components';
import { ButtonBase } from '@mui/material';

const RemoveTeamButton = ({
  id,
  key,
  onClick,
}: {
  id: string;
  key: string;
  onClick: (id: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <ButtonBase key={key} disableTouchRipple onClick={() => onClick(id)}>
      <TextV2 variant="bodyBold" color="error">
        {t('ui.event-management.learners.teams.delete')}
      </TextV2>
    </ButtonBase>
  );
};

export default RemoveTeamButton;
